import { DIVISION } from "core/interfaces";

import type { Shipping } from "~/common/interfaces/entities/shipping.interface";

export const getShippingDefault = (): Shipping => ({
	id: 0,
	firstName: "",
	lastName: "",
	phoneNumber: "",
	divisionId: 0,
	divisionName: "",
	divisionAddress: "",
	divisionCategory: DIVISION.POST_BRANCH,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	shippingHistories: [],
	orders: []
});
